export default __webpack_public_path__ + "static/media/Ubuntu-B.23965d0e.woff";